// extracted by mini-css-extract-plugin
module.exports = {"sort":"PT","selected":"QT","disabled":"RT"};